import classnames from 'classnames'

import icons from '../../../assets/icons'
import {LinkComponent} from '../../../ui/components'

import styles from './styles.module.css'

type TLogoProps = {
  href: string
  alt: string
}

export function Logo({href}: TLogoProps) {
  return (
    <LinkComponent href={href}>
      <icons.yandexDeliveryLogo className={classnames(styles.logo, styles.desktop)} />
      <icons.yandexDeliveryLogoMobile className={classnames(styles.logo, styles.mobile)} />
    </LinkComponent>
  )
}
